import { useState, useEffect } from "react";
import { toast } from "sonner";
import { X, Star, Check } from "lucide-react";
import { api } from "../lib/api";

export const SponsorModal = ({ open, onClose, business }) => {
  const [plans, setPlans] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { if (open) api.plans().then(setPlans).catch(() => {}); }, [open]);
  if (!open) return null;

  const checkout = async (lookup_key) => {
    setBusy(lookup_key);
    try {
      const res = await api.checkout({ lookup_key, origin_url: window.location.origin, business_id: business?.id });
      window.location.href = res.checkout_url;
    } catch { toast.error("No se pudo iniciar el pago."); setBusy(""); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/50 sm:items-center sm:p-4" onClick={onClose}>
      <div data-testid="sponsor-modal" className="max-h-[90vh] w-full overflow-y-auto rounded-t-3xl bg-white p-6 sm:max-w-md sm:rounded-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="font-display text-xl font-bold">Destaca tu negocio</h3>
          <button onClick={onClose} className="rounded-full p-1 hover:bg-secondary"><X className="h-5 w-5" /></button>
        </div>
        <p className="mt-1 text-sm text-muted-foreground">Aparece primero en búsquedas y categorías. Pago seguro con Stripe.</p>
        <div className="mt-4 space-y-3">
          {plans.map((p) => (
            <div key={p.lookup_key} data-testid={`plan-${p.lookup_key}`} className="rounded-2xl border border-border p-4 transition-colors hover:border-brand/40">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Star className="h-5 w-5 text-brand-gold" />
                  <span className="font-semibold">{p.label}</span>
                </div>
                {p.price && (
                  <span className="font-display text-lg font-extrabold text-brand">
                    ${p.price.amount}
                    {p.price.recurring && <span className="text-xs font-medium text-muted-foreground">/mes</span>}
                  </span>
                )}
              </div>
              <ul className="mt-2 space-y-1 text-xs text-muted-foreground">
                <li className="flex items-center gap-1.5"><Check className="h-3.5 w-3.5 text-emerald-600" /> Insignia "Destacado"</li>
                <li className="flex items-center gap-1.5"><Check className="h-3.5 w-3.5 text-emerald-600" /> Prioridad en resultados</li>
              </ul>
              <button
                data-testid={`checkout-${p.lookup_key}`}
                disabled={busy === p.lookup_key}
                onClick={() => checkout(p.lookup_key)}
                className="mt-3 h-11 w-full rounded-full bg-brand font-bold text-white hover:bg-brand-hover disabled:opacity-60"
              >
                {busy === p.lookup_key ? "Redirigiendo..." : "Contratar"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
